var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99996 6.00002C7.47329 6.00002 8.66663 4.80669 8.66663 3.33335C8.66663 1.86002 7.47329 0.666687 5.99996 0.666687C4.52663 0.666687 3.33329 1.86002 3.33329 3.33335C3.33329 4.80669 4.52663 6.00002 5.99996 6.00002ZM5.99996 7.33335C4.21996 7.33335 0.666626 8.22669 0.666626 10V11.3334H11.3333V10C11.3333 8.22669 7.77996 7.33335 5.99996 7.33335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/addUser.f5a9817fb776739d78d23d5095ccfd78.svg";
export { ForwardRef as ReactComponent };